import * as React from 'react';
import { HorizontalBar } from 'react-chartjs-2';
import {
  EventConfigProps,
  EventConfigTypes,
  WidgetProps,
  ComponentProps,
} from '@intermix-dashboard/core';
import { useThemeObserver } from '../hooks/useThemeObserver';
export const IntermixStackedBarChartComponent: React.FC<ComponentProps> = ({
  data,
  options,
  dataTransform,
  eventConfig,
}) => {
  const inputRef = React.useRef<any>(null);
  const [renderData, setRenderData] = React.useState<any>(null);
  const { display } = useThemeObserver();

  React.useEffect(() => {
    if (dataTransform) {
      setRenderData(dataTransform(data, options));
    } else {
      setRenderData(data);
    }
  }, [data, options.title, dataTransform]);

  return (
    <div
      ref={inputRef}
      style={{ display: 'flex', width: '100%', flex: '1' }}
      id="intermix-card"
    >
      <>
        {renderData && display && (
          <HorizontalBar
            type="horizontalBar"
            onElementsClick={(elems) => {
              if (
                elems &&
                elems.length > 0 &&
                typeof elems[0]._index !== 'undefined'
              ) {
                const defaultEventConfig = eventConfig?.find(
                  (item: EventConfigProps) =>
                    item.type === EventConfigTypes.DEFAULT
                );
                if (defaultEventConfig) {
                  const event = new CustomEvent('intermix-event', {
                    detail: {
                      key: defaultEventConfig.key,
                      value: elems[0]._model.label,
                    },
                    bubbles: true,
                    cancelable: false,
                    composed: true, // makes the event jump shadow DOM boundary); */
                  });
                  (inputRef.current as any).dispatchEvent(event);
                }
              }
            }}
            data={JSON.parse(JSON.stringify(renderData))}
            options={
              {
                indexAxis: 'y',
                responsive: true,
                title: {
                  display: true,
                  text: options.title ? options.title : '',
                },
                scales: {
                  xAxes: [
                    {
                      stacked: true, // this should be set to make the bars stacked
                      ticks: {
                        beginAtZero: true,
                      },
                    },
                  ],
                  yAxes: [
                    {
                      stacked: true, // this also..

                      ticks: {
                        beginAtZero: true,
                      },
                    },
                  ],
                },
              } as any
            }
          />
        )}
      </>
    </div>
  );
};

export const IntermixStackedBarChartWidget: WidgetProps = {
  id: 'stream-stacked-bar',
  component: IntermixStackedBarChartComponent,
};
